import componentsClasses from '@app/styles/components.module.css';
import { getBRCurrencyFormat } from '@app/utils/formmater';
import { TagManager } from '@app/utils/tag-manager';
import { Add, Remove } from '@material-ui/icons';
import cls from 'classnames';
import React from 'react';
import { useMenuItemDetailsContext } from '../context';
import { createInvalidMessage } from '../helpers';
import classes from './styles.module.css';

type Props = {
  onAddMenuItemClick: () => void;
  addItemButtonEnabled: boolean;
};

export default function BillingResult({ onAddMenuItemClick, addItemButtonEnabled }: Props) {
  const { total, amount, setAmount, invalidComplementGroup, menuItem } = useMenuItemDetailsContext();

  function handleMinusClick() {
    setAmount((oldValue) => oldValue - 1);
  }

  function handlePlusClick() {
    if (invalidComplementGroup) {
      alert(createInvalidMessage(menuItem, invalidComplementGroup));
      return;
    }
    setAmount((oldValue) => oldValue + 1);
  }

  return (
    <div className={classes.container}>
      <div className={classes.amountControl}>
        <button className={classes.amountButton} disabled={amount <= 1} onClick={handleMinusClick}>
          <Remove style={{ color: amount > 1 ? '#FF6161' : '#B5B5B5' }} />
        </button>
        <span>{amount}</span>
        <button className={classes.amountButton} onClick={handlePlusClick}>
          <Add style={{ color: '#65D870' }} />
        </button>
      </div>
      <button
        className={cls(componentsClasses.successButton, classes.addButton, TagManager.Classes.AddToCart)}
        style={!addItemButtonEnabled ? { backgroundColor: '#ccc' } : {}}
        onClick={onAddMenuItemClick}
        data-cy="add-menu-item-button"
      >
        <span className={TagManager.Classes.AddToCart}>Adicionar</span>
        <span className={TagManager.Classes.AddToCart}>{getBRCurrencyFormat(total * amount)}</span>
      </button>
    </div>
  );
}
